import { useState } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
// @ts-expect-error Library not migrated yet
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { useAuthState } from '../../../app/hooks/useAuthState';
import RequestPrivateBetaDialog from '../EnrollmentButtonDialogs/RequestPrivateBetaDialog';
import useFetchOrgData from '../../hooks/useFetchOrgData';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RequestToJoinEnrollmentButton = ({
  enrollType,
  enrollmentStatus,
  gate,
  productUpdateId,
  isBetaClosed = false,
  rolloutId,
  size,
  title,
  untranslatedTitle
}) => {
  const theme = useTheme();
  const isTrellis = isTrellisTheme(theme);
  const [requestDialogOpen, setRequestDialogOpen] = useState(false);
  const {
    portal,
    hasBetaAccess
  } = useAuthState();
  const isSlowRollout = portal && portal.isSlowRollout;
  const {
    isInOrg,
    isInOrgAndSuperAdmin,
    loading
  } = useFetchOrgData();
  const btnUsePrimary = isTrellis ? 'primary' : 'tertiary';
  const btnUseSecondary = isTrellis ? 'secondary' : 'tertiary-light';
  const isDisabled = !hasBetaAccess || enrollmentStatus === 'PENDING_APPROVAL' || enrollmentStatus === 'CANNOT_ENROLL' || enrollmentStatus === 'CANNOT_ENROLL_TRIAL_PORTAL' || enrollType === 'ORGANIZATIONS_ONLY' && !isInOrgAndSuperAdmin;
  const getDisabledMessage = () => {
    if (!hasBetaAccess) {
      return I18n.text('app.betas.disabled.noScope');
    } else if (enrollmentStatus === 'PENDING_APPROVAL') {
      return I18n.text('app.betas.request.disabled.alreadyRequested');
    } else if (enrollmentStatus === 'CANNOT_ENROLL') {
      return I18n.text('app.betas.disabled.cannotEnroll');
    } else if (enrollmentStatus === 'CANNOT_ENROLL_TRIAL_PORTAL') {
      return I18n.text('app.betas.disabled.trialPortal');
    } else if (!isInOrg) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [I18n.text('app.betas.join.disabledOptionNotInOrg'), ' ', /*#__PURE__*/_jsx(KnowledgeBaseButton, {
          url: "https://knowledge.hubspot.com/account-management/set-up-multi-account-management",
          use: "link",
          children: I18n.text('app.betas.disabled.learnMore')
        })]
      });
    } else if (!isInOrgAndSuperAdmin) {
      return I18n.text('app.betas.disabled.notOrgSuperAdmin');
    }
    return null;
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Tooltip, {
      disabled: !isDisabled,
      title: getDisabledMessage(),
      children: enrollType === 'ORGANIZATIONS_ONLY' ? /*#__PURE__*/_jsx(LoadingButton, {
        loading: loading,
        failed: true,
        disabled: isDisabled,
        use: loading ? btnUseSecondary : btnUsePrimary,
        size: size,
        block: true,
        onClick: () => {
          setRequestDialogOpen(true);
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.buttons.request"
        })
      }) : /*#__PURE__*/_jsx(Button, {
        disabled: isDisabled,
        use: btnUsePrimary,
        size: size,
        block: true,
        onClick: () => {
          setRequestDialogOpen(true);
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.buttons.request"
        })
      })
    }), requestDialogOpen && /*#__PURE__*/_jsx(RequestPrivateBetaDialog, {
      enrollType: enrollType,
      gate: gate,
      rolloutId: rolloutId,
      productUpdateId: productUpdateId,
      isSlowRollout: isSlowRollout,
      isBetaClosed: isBetaClosed,
      title: title,
      untranslatedTitle: untranslatedTitle,
      onClose: () => {
        setRequestDialogOpen(false);
      }
    })]
  });
};
export default RequestToJoinEnrollmentButton;